import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Layout/Footer';
import Tabs from '../../Components/Tab/FeaturedPropertyTab';
import { RentIcon } from '../../Assets/Icons/rentIcon';
import { BuyIcon } from '../../Assets/Icons/buyIcon';
import { CoOwnIcon } from '../../Assets/Icons/coOwnIcon';
import { ReactComponent as Bed } from '../../Assets/Icons/bedcardIcon.svg';
import { ReactComponent as Shower } from '../../Assets/Icons/ShowerIcon.svg';
import { ReactComponent as Toilet } from '../../Assets/Icons/toiletIcon.svg';
import { useLandingPage } from '../../Services/hooks/landingpage';
import { formatCurrency } from '../../Utils/currencyFormat';
import { PageLoader } from '../../Components/Loader/pageLoader';
import { CustomSearch } from '../../Components/Form/CustomSearch';
import { Pagination } from '../../Components/Pagination/pagination';
import { useProperty } from '../../Services/hooks/PropertyCoOwn';
import { User } from '../../Storeredux/constants/actionTypes';
import { shortenSentence } from '../../Utils/shorttenText';
import { StorageBaseURL } from '../../Services/constant/Action';


function  Property() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [type, setType] = useState<string | undefined>('rent');
  const screenWidth = window.innerWidth;
  const { getFilteredHomeProperty, error, paginate  } = useLandingPage();
  const { getBuyProperties, property, loading: pageLoading, getPropertyCoOwnData } = useProperty();

  const tabs = [
    { id: 'rent', label: 'Rent', icon: RentIcon },
    { id: 'buy', label: 'Buy', icon: BuyIcon },
    { id: 'coOwn', label: 'Co-own', icon: CoOwnIcon },

  ];
  // const [tabLabel, set]

  const getType = (name: any) => {
    switch (name) {
      case 'rent':
        return 'rent';
      case 'buy':
        return 'mortgage';
      case 'coOwn':
        return 'all';
    }
  };
  const handleTabChange = (index: number) => {
    console.log('this', index);
    const selectedType = getType(tabs[index].id);
    setActiveTabIndex(index);
    getType(tabs[index].id);
    if (selectedType === 'all') {
      getPropertyCoOwnData({ type: 'all' });
    } else {
      getBuyProperties({ type: selectedType });
    }

    setType(getType(tabs[index].id));
    console.log(`Selected Tab: ${tabs[index].id}   ${getType(tabs[index].id)}`);
    const tabLabel = tabs[index].id;
    console.log(`Selected Tab: ${tabLabel}`);
  };
  const handleSearch = async (params: any) => {
    await getFilteredHomeProperty(params);
  };

  const isValidHttpsUrl = (url: string) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'https:';
    } catch (errors: any) {
      console.log(errors);
      return false; // If it's not a valid URL, return false
    }
  };


  useEffect(() => {
    if (type === 'all') {
      getPropertyCoOwnData({ type: 'all' });
    } else {
      getBuyProperties({ type: type });
    }
  }, [type]);
  return (
      <div className={'py-10'}>
        <div className='text-center '>
          {/*<h1 className='text-2xl md:text-3xl lg:text-4xl font-bold py-2'>*/}
          {/*            Featured properties*/}
          {/*</h1>*/}
          <div className={'lg:w-10/12 mx-auto bg-[#D9FCD5] rounded-xl py-7 flex flex-col gap-3.5'}>
            <div className={'flex justify-center py-2'}>
              <Tabs tabs={tabs} activeTabIndex={activeTabIndex} onTabChange={handleTabChange}/>
            </div>
            <CustomSearch onSearch={handleSearch}/>
            {error && (<p className='text-sm text-red-900 italic pt-1'>
              {error}
            </p>)}
          </div>
        </div>
        {pageLoading ?
            <div className='gap-7 w-fit justify-center mx-auto mt-7 flex flex-wrap h-52'>
              <PageLoader/>
            </div> : property?.length === 0 ? (
            <div className='featuredProperty lg:w-10/12 mx-auto !pb-20'>
              <p>No Property available</p>
            </div>
            ) :
              <>
                <div className='featuredProperty lg:w-10/12 mx-auto !pb-20'>
                  {type === 'all' ?
                    property?.map((investment: User, index) => {
                      return (
                        <a href="https://kekere.com/register/co-own" target="_blank" key={index}
                           className={`rounded-3xl overflow-hidden lg:w-[255px] xl:w-[285px] md:w-[225px] bg-white border border-custom-grey ${screenWidth <= 390 ? 'w-[285px]' : 'w-[240px]'}`}>
                          <div className="relative">
                            <img src={investment?.property.thumbnail} alt="investment"
                                 className="w-full h-44 bg-green-200" />
                            <span
                              className={`absolute uppercase bg-white top-2 font-semibold left-2 rounded-full text-xs py-1 px-3 ${investment?.property?.available_slots === 0 ? 'text-red-500' : 'text-green-600'}`}>
                          {investment?.property?.available_slots === 0 ? 'Sold Out' : 'Active'}
                        </span>
                          </div>
                          <div className="p-3 pb-4 flex flex-col gap-y-3">
                            <div className={'flex gap-2 '}>
                          <span
                            className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Bed />
                            </span>
                            <span>{investment?.property?.details?.rooms_no}</span>
                          </span>
                              <span
                                className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Shower />
                            </span>
                            <span>{investment?.property?.details?.toilets_no}</span>
                          </span>
                              <span
                                className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Toilet />
                            </span>
                            <span>{investment?.property?.details?.toilets_no}</span>
                          </span>
                            </div>
                            <h1 className="">{shortenSentence(investment?.property?.details?.property_title)}</h1>
                            <div>
                              <div
                                className={`w-full  rounded-full h-2 ${investment?.percent_funded === 100 ? 'bg-red-600' : 'bg-[#3AC26733]'}`}
                                style={{ mixBlendMode: 'multiply' }}>
                                <div
                                  className={` h-2 rounded-full ${investment?.percent_funded === 100 ? 'bg-red-600' : 'bg-[#3AC267]'}`}
                                  style={{ width: `${investment?.percent_funded}%` }}></div>
                              </div>
                              <div className={'flex justify-between w-full text-xxs text-custom-darkgreen pt-0.5'}>
                                <p>
                                  {formatCurrency(investment?.amount_invested?.totalInvestedAmount)} Invested
                                </p>
                                <p>
                                  {`${investment?.property?.available_slots} ${investment?.property?.available_slots === 0 ? 'slot' : 'slots'}`} remaining
                                </p>
                              </div>
                            </div>
                            <div className={'bg-[#F9F9F9] p-3 rounded-2xl flex flex-col gap-y-2 w-full'}>
                              <div className="flex justify-between text-xs">
                                <span>Price Per Slot:</span>
                                <span
                                  className={'font-semibold'}>{formatCurrency(investment?.price_per_slot)}</span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span>Yearly Investment Return:</span>
                                <span
                                  className={'font-semibold'}>{investment?.yearly_investment_return || 0}%</span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span>Earnings On Slot:</span>
                                <span
                                  className={'font-semibold'}>{formatCurrency(investment?.earning_on_slot || 0)}</span>
                              </div>
                            </div>
                          </div>
                        </a>
                      );
                    })
                    :
                    property?.map((investment: any, index) => {
                      return (
                        <Link to={`/app/properties/${investment?.id}`} key={index}
                              className="rounded-3xl overflow-hidden w-[305px] sm:w-[200px] md:w-[305px] bg-white border border-custom-grey">
                          <div className="relative">
                            <img src={isValidHttpsUrl(investment?.thumbnail) ? investment?.thumbnail : `${StorageBaseURL}${investment?.thumbnail}`} alt="investment"
                                 className="w-full h-44 bg-green-200" />
                            <span
                              className={`absolute uppercase bg-white top-2 font-semibold left-2 rounded-full text-xs py-1 px-2.5 ${investment?.property?.available_slots === 0 ? 'text-red-500' : 'text-green-600'}`}>
                          {investment?.status === 0 ? 'Rent' : 'Active'}
                        </span>
                          </div>
                          <div className="p-3">
                            <div className={'flex gap-2 py-2'}>
                        <span
                          className={'bg-[#E5E5E5] flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                          <span>
                            <Bed />
                          </span>
                          <span>{investment?.rooms}</span>
                        </span>
                              <span
                                className={'bg-[#E5E5E5] flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Shower />
                            </span>
                            <span>{investment?.showers}</span>
                          </span>
                              <span
                                className={'bg-[#E5E5E5] flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Toilet />
                            </span>
                            <span>{investment?.toilets}</span>
                          </span>
                            </div>
                            <h1 className="py-2">{investment?.title}</h1>
                            <div className={'flex justify-between bg-[#F9F9F9] text-sm rounded-lg py-2 px-2.5'}>
                              <h1>{type === 'rent' ? 'Monthly Rent:' : 'Property Price:'} </h1>
                              <p>{formatCurrency(Number(investment?.fixed_amount))}</p>
                            </div>
                          </div>
                        </Link>
                      );
                    })
                  }
                </div>
              </>
              }
              <div className={'pb-12 flex justify-end lg:w-10/12 mx-auto'}>
                <Pagination paginate={paginate} getPropertyCoOwnData={getPropertyCoOwnData} />
              </div>
              <Footer />
            </div>

  )
  ;
}

export default Property;
